var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.items && _vm.items.length
    ? _c(
        "w-dropdown",
        {
          staticClass: "finish-dropdown",
          class: { light: _vm.light },
          attrs: { items: _vm.items, up: _vm.up, disabled: _vm.disabled },
          on: {
            click: function ($event) {
              return _vm.onItemClick($event)
            },
          },
        },
        [
          _c(
            "button",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: _vm.tooltip,
                  expression: "tooltip",
                },
              ],
              staticClass: "w-button",
              class: { disabled: _vm.disabled, light: _vm.light },
              attrs: { disabled: _vm.disabled },
            },
            [
              _c("span", { staticClass: "icon", class: _vm.icon }),
              _vm._t("default"),
            ],
            2
          ),
        ]
      )
    : _c(
        "button",
        {
          directives: [
            {
              name: "tooltip",
              rawName: "v-tooltip",
              value: _vm.tooltip,
              expression: "tooltip",
            },
          ],
          staticClass: "w-button",
          class: { disabled: _vm.disabled, light: _vm.light },
          attrs: { disabled: _vm.disabled },
          on: {
            click: function ($event) {
              return _vm.onClick()
            },
          },
        },
        [
          _c("span", { staticClass: "icon", class: _vm.icon }),
          _vm._t("default"),
        ],
        2
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }